import { render } from "./Stages.vue?vue&type=template&id=96b2de5e&scoped=true"
import script from "./Stages.vue?vue&type=script&lang=js"
export * from "./Stages.vue?vue&type=script&lang=js"

import "./Stages.vue?vue&type=style&index=0&id=96b2de5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b2de5e"]])

export default __exports__